import { makeStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import React from 'react';
import { theme } from '../../../theme/theme';

const useDataDisplayCardClasses = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        padding: 20,
        gap: 20,
        borderRadius: 5,
        boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.14)',
        background: theme.colors.darkBlue[2],
        '& > span': {
            color: theme.colors.white,
            ...theme.typography.headings.h6,
            marginBottom: 0,
            textTransform: 'uppercase',
        },
    },
    stat: {
        display: 'flex',
        alignSelf: 'center',
        width: 140,
        height: 140,
        padding: 6,
        margin: 'auto',
        borderRadius: '50%',
        '& > div': {
            borderRadius: '50%',
            flex: 1,
            backgroundColor: theme.colors.darkBlue[2],
        },
    },
    labels: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
        color: theme.colors.white,
        '& > span:first-child': {
            ...theme.typography.displays.d2,
            textAlign: 'center',
        },
        '& > span:last-child': {
            ...theme.typography.content.label.default,
            textAlign: 'center',
        },
    },
});

/**
 * Display information about a single data point.
 *
 * @param props.fetching show fetching skeletons
 * @param props.color widget color
 * @param props.name card name
 * @param props.main the text information
 * @param props.ratio ratio of the data point
 * @param props.background color of the unfilled part of the widget
 */
export const DataDisplayCard = (props: {
    fetching?: boolean;
    color: [string, string?];
    name: string;
    main: string;
    ratio: number;
    background?: string;
}) => {
    const classes = useDataDisplayCardClasses();
    const background = `conic-gradient(
        ${props.color[0]} 0%,
        ${props.color[1 % props.color.length]} ${props.ratio * 100}%,
        ${props.background ?? 'white'} ${props.ratio * 100}%
    )`;

    if (props.fetching)
        return (
            <div className={classes.root}>
                <Skeleton />
                <Skeleton className={classes.stat} variant='circle' />
            </div>
        );

    return (
        <div className={classes.root}>
            <span>{props.name}</span>
            <div className={classes.stat} style={{ background }}>
                <div className={classes.labels}>
                    <span>{`${props.main} `.slice(0, props.main.indexOf(' '))}</span>
                    <span>{`${props.main} `.slice(props.main.indexOf(' '))}</span>
                </div>
            </div>
        </div>
    );
};
